// Constants
import { TOOLTIP_STYLE_BOX } from 'ChartApp/ts/features/charts-shared/constants';
import { AttributionCategorization } from 'SecuritiesApp/ts/interfaces/attribution.interface';
export const ATTRIBUTION_PERFORMANCE_CHART_OPTIONS = {
    chart: {
        height: 260,
    },
    xAxis: {
        // make every other column light gray
        alternateGridColor: '#0000000d',
        crosshair: false,
        labels: {
            enabled: false,
        },
        tickmarkPlacement: 'between',
    },
};
export const ATTRIBUTION_PERFORMANCE_CHART_CONFIGURABLE_OPTIONS = {
    dynamicHeight: false,
    showLatestValueLabels: false,
    tooltipStyle: TOOLTIP_STYLE_BOX,
    yAxisWidth: 155,
};
export const SECTOR_DISPLAY_NAMES = {
    'Communication Services': 'Comm. Services',
};
export const RELATIVE_ATTRIBUTION_EXPANDABLE_CATEGORIZATIONS = [
    AttributionCategorization.SECTOR,
    AttributionCategorization.EQUITY_STYLE,
    AttributionCategorization.BROAD_ASSET_CLASS,
];
